module.exports = __webpack_public_path__ + "static/media/kop_surat.c3feefc0.png";